module.exports = "/_next/static/images/74cda69df1ff4d1204381373751e5dfb-parcelar_fatura.png.webp";